"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStepperData = exports.StepperProvider = exports.StepperContext = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const StepperContext = exports.StepperContext = /*#__PURE__*/(0, _react.createContext)({
  stepperData: {
    setActiveStep: () => {},
    activeStep: 0,
    setManualChange: () => {},
    manualChange: false,
    stepsOrder: [],
    setStepsOrder: () => {}
  }
});
const StepperProvider = ({
  children
}) => {
  const [activeStep, setActiveStep] = (0, _react.useState)(0);
  const [manualChange, setManualChange] = (0, _react.useState)(false);
  const [stepsOrder, setStepsOrder] = (0, _react.useState)([]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StepperContext.Provider, {
    value: {
      stepperData: {
        activeStep,
        setActiveStep,
        manualChange,
        setManualChange,
        stepsOrder,
        setStepsOrder
      }
    },
    children: children
  });
};
exports.StepperProvider = StepperProvider;
const useStepperData = () => (0, _react.useContext)(StepperContext);
exports.useStepperData = useStepperData;